webpackJsonp([231608221292675],{

/***/ 227:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.apiRunner = apiRunner;
	exports.apiRunnerAsync = apiRunnerAsync;
	var plugins = [];
	// During bootstrap, we write requires at top of this file which looks
	// basically like:
	// var plugins = [
	//   require('/path/to/plugin1/gatsby-browser.js'),
	//   require('/path/to/plugin2/gatsby-browser.js'),
	// ]
	
	function apiRunner(api, args, defaultReturn) {
	  var results = plugins.map(function (plugin) {
	    if (plugin.plugin[api]) {
	      var result = plugin.plugin[api](args, plugin.options);
	      return result;
	    }
	  });
	
	  // Filter out undefined results.
	  results = results.filter(function (result) {
	    return typeof result !== "undefined";
	  });
	
	  if (results.length > 0) {
	    return results;
	  } else if (defaultReturn) {
	    return [defaultReturn];
	  } else {
	    return [];
	  }
	}
	
	function apiRunnerAsync(api, args, defaultReturn) {
	  return plugins.reduce(function (previous, next) {
	    return next.plugin[api] ? previous.then(function () {
	      return next.plugin[api](args, next.options);
	    }) : previous;
	  }, Promise.resolve());
	}

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _exports$json;
	
	// prefer default export if available
	var preferDefault = function preferDefault(m) {
	  return m && m.default || m;
	};
	
	exports.components = {
	  "component---src-templates-article-listing-js": __webpack_require__(341),
	  "component---src-templates-article-js": __webpack_require__(340),
	  "component---src-pages-404-js": __webpack_require__(336),
	  "component---src-pages-index-js": __webpack_require__(337),
	  "component---src-pages-photos-index-js": __webpack_require__(339),
	  "component---src-pages-music-index-js": __webpack_require__(338)
	};
	
	exports.json = (_exports$json = {
	  "layout-index.json": __webpack_require__(11),
	  "articles-1.json": __webpack_require__(344)
	}, _exports$json["layout-index.json"] = __webpack_require__(11), _exports$json["articles-2.json"] = __webpack_require__(345), _exports$json["layout-index.json"] = __webpack_require__(11), _exports$json["articles-3.json"] = __webpack_require__(389), _exports$json["layout-index.json"] = __webpack_require__(11), _exports$json["articles-4.json"] = __webpack_require__(390), _exports$json["layout-index.json"] = __webpack_require__(11), _exports$json["articles-5.json"] = __webpack_require__(391), _exports$json["layout-index.json"] = __webpack_require__(11), _exports$json["articles-6.json"] = __webpack_require__(392), _exports$json["layout-index.json"] = __webpack_require__(11), _exports$json["articles-7.json"] = __webpack_require__(393), _exports$json["layout-index.json"] = __webpack_require__(11), _exports$json["articles-8.json"] = __webpack_require__(394), _exports$json["layout-index.json"] = __webpack_require__(11), _exports$json["articles-9.json"] = __webpack_require__(395), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2018-02-a-little-information.json"] = __webpack_require__(388), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2017-11-loop-city.json"] = __webpack_require__(387), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2017-10-memory-lane.json"] = __webpack_require__(386), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2016-07-dont-use-enum-umkay.json"] = __webpack_require__(385), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2014-10-a-new-site.json"] = __webpack_require__(384), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["photos-my-photos.json"] = __webpack_require__(399), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2008-12-all-i-need-is-a-guitar-solo.json"] = __webpack_require__(383), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2008-07-treasures-of-the-past-promises-of-the-future.json"] = __webpack_require__(382), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2008-04-i-think-im-turning-open-source.json"] = __webpack_require__(381), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2008-04-bye-bye-u-3.json"] = __webpack_require__(380), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2007-07-happy-4th.json"] = __webpack_require__(379), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2006-12-he-must-be-crazy.json"] = __webpack_require__(376), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2006-12-carbon-monoxide-and-you.json"] = __webpack_require__(375), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2006-10-finally-all-back-in-business.json"] = __webpack_require__(374), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2007-07-finally-all-back-in-business.json"] = __webpack_require__(378), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2006-09-more-news-from-the-homestead.json"] = __webpack_require__(373), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2006-for-those-with-wimpy-stomaches.json"] = __webpack_require__(377), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2006-05-ouch-my-ground.json"] = __webpack_require__(371), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2006-05-when-you-just-cant-wait.json"] = __webpack_require__(372), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2006-04-got-my-extra.json"] = __webpack_require__(368), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2006-04-its-full-of-code.json"] = __webpack_require__(369), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2006-04-looking-at-radios.json"] = __webpack_require__(370), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2006-03-got-my-callsign.json"] = __webpack_require__(362), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2006-03-wires-up-passed-the-test.json"] = __webpack_require__(367), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2006-03-new-tune.json"] = __webpack_require__(365), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2006-03-shiny-new-domain.json"] = __webpack_require__(366), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2006-03-lessons-in-morse-code.json"] = __webpack_require__(363), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2006-03-my-first-homebrew-radio.json"] = __webpack_require__(364), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2005-09-what-are-the-odds.json"] = __webpack_require__(361), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2005-09-i-actually-lost-simcity.json"] = __webpack_require__(358), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2005-09-the-40-dollar-usb-cable.json"] = __webpack_require__(360), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2005-09-new-dinning-room-floors.json"] = __webpack_require__(359), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2005-08-welcome-back-students-bye-bye-internet.json"] = __webpack_require__(356), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2005-08-why-i-hate-css.json"] = __webpack_require__(357), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2005-08-ironevents-finally-under-construction.json"] = __webpack_require__(355), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2004-10-how-marvelous.json"] = __webpack_require__(354), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2004-07-collapsable-folder-list.json"] = __webpack_require__(346), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2004-07-somewhere-up-in-the-sky.json"] = __webpack_require__(351), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2004-07-the-miracle-of-life.json"] = __webpack_require__(352), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2004-07-this-city-shall-surley-live.json"] = __webpack_require__(353), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2004-07-score-another-for-good-tunage.json"] = __webpack_require__(350), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2004-07-fun-with-networking.json"] = __webpack_require__(347), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2004-07-life-before-laptops.json"] = __webpack_require__(349), _exports$json["layout-article.json"] = __webpack_require__(2), _exports$json["articles-2004-07-holy-bloggers-batman.json"] = __webpack_require__(348), _exports$json["layout-index.json"] = __webpack_require__(11), _exports$json["404.json"] = __webpack_require__(342), _exports$json["layout-index.json"] = __webpack_require__(11), _exports$json["index.json"] = __webpack_require__(396), _exports$json["layout-index.json"] = __webpack_require__(11), _exports$json["404-html.json"] = __webpack_require__(343), _exports$json["layout-index.json"] = __webpack_require__(11), _exports$json["photos.json"] = __webpack_require__(398), _exports$json["layout-index.json"] = __webpack_require__(11), _exports$json["music.json"] = __webpack_require__(397), _exports$json);
	
	exports.layouts = {
	  "component---src-layouts-index-js": __webpack_require__(335),
	  "component---src-layouts-article-js": __webpack_require__(334)
	};

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _loader = __webpack_require__(138);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _emitter = __webpack_require__(57);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DefaultLayout = function DefaultLayout(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    "div",
	    null,
	    children()
	  );
	};
	
	// Pass pathname in as prop.
	// component will try fetching resources. If they exist,
	// will just render, else will render null.
	
	var ComponentRenderer = function (_React$Component) {
	  _inherits(ComponentRenderer, _React$Component);
	
	  function ComponentRenderer(props) {
	    _classCallCheck(this, ComponentRenderer);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.state = {
	      location: props.location,
	      pageResources: _loader2.default.getResourcesForPathname(props.location.pathname)
	    };
	    return _this;
	  }
	
	  ComponentRenderer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    if (this.state.location.pathname !== nextProps.location.pathname) {
	      var pageResources = _loader2.default.getResourcesForPathname(nextProps.location.pathname);
	      if (!pageResources) {
	        // Page resources won't be set in cases where the browser back button
	        // or forward button is pushed as we can't wait as normal for resources
	        // to load before changing the page.
	        _loader2.default.getResourcesForPathname(nextProps.location.pathname, function (pageResources) {
	          _this2.setState({
	            location: nextProps.location,
	            pageResources: pageResources
	          });
	        });
	      } else {
	        this.setState({
	          location: nextProps.location,
	          pageResources: pageResources
	        });
	      }
	    }
	  };
	
	  ComponentRenderer.prototype.componentDidMount = function componentDidMount() {
	    var _this3 = this;
	
	    // Listen to events so when our page gets updated, we can transition.
	    // This is only useful on delayed transitions as the page will get rendered
	    // without the necessary page resources and then re-render once those come in.
	    _emitter2.default.on("onPostLoadPageResources", function (e) {
	      if (e.page.path === _loader2.default.getPage(_this3.state.location.pathname).path) {
	        _this3.setState({ pageResources: e.pageResources });
	      }
	    });
	  };
	
	  ComponentRenderer.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	    // 404
	    if (!nextState.pageResources) {
	      return true;
	    }
	
	    // Check if the component or json have changed.
	    if (!this.state.pageResources && nextState.pageResources) {
	      return true;
	    }
	
	    if (this.state.pageResources.component !== nextState.pageResources.component) {
	      return true;
	    }
	
	    if (this.state.pageResources.json !== nextState.pageResources.json) {
	      return true;
	    }
	
	    // Check if location has changed on a page using internal routing
	    // via matchPath configuration.
	    if (this.state.location.key !== nextState.location.key && nextState.pageResources.page && (nextState.pageResources.page.matchPath || nextState.pageResources.page.path)) {
	      return true;
	    }
	
	    return false;
	  };
	
	  ComponentRenderer.prototype.render = function render() {
	    // If page.
	    if (this.props.page) {
	      if (this.state.pageResources) {
	        return (0, _react.createElement)(this.state.pageResources.component, _extends({
	          key: this.props.location.pathname
	        }, this.props, this.state.pageResources.json));
	      } else {
	        return null;
	      }
	      // If layout.
	    } else if (this.props.layout) {
	      return (0, _react.createElement)(this.state.pageResources && this.state.pageResources.layout ? this.state.pageResources.layout : DefaultLayout, _extends({
	        key: this.state.pageResources && this.state.pageResources.layout ? this.state.pageResources.layout : "DefaultLayout"
	      }, this.props));
	    } else {
	      return null;
	    }
	  };
	
	  return ComponentRenderer;
	}(_react2.default.Component);
	
	ComponentRenderer.propTypes = {
	  page: _propTypes2.default.bool,
	  layout: _propTypes2.default.bool,
	  location: _propTypes2.default.object
	};
	
	exports.default = ComponentRenderer;
	module.exports = exports["default"];

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _mitt = __webpack_require__(543);
	
	var _mitt2 = _interopRequireDefault(_mitt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emitter = (0, _mitt2.default)();
	module.exports = emitter;

/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _reactRouterDom = __webpack_require__(82);
	
	var pageCache = {}; // TODO add tests especially for handling prefixed links.
	
	
	module.exports = function (pages) {
	  var pathPrefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
	  return function (rawPathname) {
	    var pathname = decodeURIComponent(rawPathname);
	    // Remove the pathPrefix from the pathname.
	    var trimmedPathname = pathname.slice(pathPrefix.length);
	
	    // Remove any hashfragment
	    if (trimmedPathname.split("#").length > 1) {
	      trimmedPathname = trimmedPathname.split("#").slice(0, -1).join("");
	    }
	
	    // Remove search query
	    if (trimmedPathname.split("?").length > 1) {
	      trimmedPathname = trimmedPathname.split("?").slice(0, -1).join("");
	    }
	
	    if (pageCache[trimmedPathname]) {
	      return pageCache[trimmedPathname];
	    }
	
	    var foundPage = void 0;
	    // Array.prototype.find is not supported in IE so we use this somewhat odd
	    // work around.
	    pages.some(function (page) {
	      if (page.matchPath) {
	        // Try both the path and matchPath
	        if ((0, _reactRouterDom.matchPath)(trimmedPathname, { path: page.path }) || (0, _reactRouterDom.matchPath)(trimmedPathname, {
	          path: page.matchPath
	        })) {
	          foundPage = page;
	          pageCache[trimmedPathname] = page;
	          return true;
	        }
	      } else {
	        if ((0, _reactRouterDom.matchPath)(trimmedPathname, {
	          path: page.path,
	          exact: true
	        })) {
	          foundPage = page;
	          pageCache[trimmedPathname] = page;
	          return true;
	        }
	
	        // Finally, try and match request with default document.
	        if ((0, _reactRouterDom.matchPath)(trimmedPathname, {
	          path: page.path + "index.html"
	        })) {
	          foundPage = page;
	          pageCache[trimmedPathname] = page;
	          return true;
	        }
	      }
	
	      return false;
	    });
	
	    return foundPage;
	  };
	};

/***/ }),

/***/ 343:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(178698757827068, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(407) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(254022195166212, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(408) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 344:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(120289305084215, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(409) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 345:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(269507086353330, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(410) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 346:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(209108384390701, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(411) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 347:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(178053535692167, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(412) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 348:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(172806167631297, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(413) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 349:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(48697062332887, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(414) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(168013785274269, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(415) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 351:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(93226270876587, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(416) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(88691311302301, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(417) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 353:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(266059961586883, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(418) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 354:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(247354857995785, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(419) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 355:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(172467454322931, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(420) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 356:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(131187406151214, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(421) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 357:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(164908667355208, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(422) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 358:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(254253006669160, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(423) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 359:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(7867983585208, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(424) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 360:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(98747961989979, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(425) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 361:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(194246877174713, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(426) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 362:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(160038665392547, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(427) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 363:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(271167537966395, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(428) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 364:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(49419086200317, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(429) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 365:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(267984221869951, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(430) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 366:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(6015121206138, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(431) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 367:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(174679746929452, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(432) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(129367142672770, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(433) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(19801280020984, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(434) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 370:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(68187924412366, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(435) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(13808545336376, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(436) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(222075216226526, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(437) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(187271916041004, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(438) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(268699159605275, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(439) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(123220182183552, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(440) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 376:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(231285563014119, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(441) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 377:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(237906279959799, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(442) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 378:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(78037857162840, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(443) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 379:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(227952741029231, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(444) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 380:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(249297498895628, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(445) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 381:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(37437013160638, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(446) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 382:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(135780144188887, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(447) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 383:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(249501388429416, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(448) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 384:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(171422777945114, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(449) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 385:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(223157097422758, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(450) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 386:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(215732614462990, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(451) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 387:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(256101852977854, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(452) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 388:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(1579331396352, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(453) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 389:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(143360680050005, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(454) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 390:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(213449887146903, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(455) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 391:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(229226919027543, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(456) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 392:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(177890422846541, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(457) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 393:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(270222354306401, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(458) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 394:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(253939881115069, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(459) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 395:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(212591436666080, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(460) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 396:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(142629428675168, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(461) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(60335399758886, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(108) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(60335399758886, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(109) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 397:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(192093361865127, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(462) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(63601432018379, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(463) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(162494902762776, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(464) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 334:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(191130700161134, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(231) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 335:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(114276838955818, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(232) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _findPage = __webpack_require__(230);
	
	var _findPage2 = _interopRequireDefault(_findPage);
	
	var _emitter = __webpack_require__(57);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var findPage = void 0;
	
	var syncRequires = {};
	var asyncRequires = {};
	var pathScriptsCache = {};
	var resourceStrCache = {};
	var resourceCache = {};
	var pages = [];
	// Note we're not actively using the path data atm. There
	// could be future optimizations however around trying to ensure
	// we load all resources for likely-to-be-visited paths.
	var pathArray = [];
	var pathCount = {};
	var resourcesArray = [];
	var resourcesCount = {};
	var preferDefault = function preferDefault(m) {
	  return m && m.default || m;
	};
	var prefetcher = void 0;
	var inInitialRender = true;
	
	// Prefetcher logic
	if (true) {
	  prefetcher = __webpack_require__(233)({
	    getNextQueuedResources: function getNextQueuedResources() {
	      return resourcesArray.slice(-1)[0];
	    },
	    createResourceDownload: function createResourceDownload(resourceName) {
	      fetchResource(resourceName, function () {
	        resourcesArray = resourcesArray.filter(function (r) {
	          return r !== resourceName;
	        });
	        prefetcher.onResourcedFinished(resourceName);
	      });
	    }
	  });
	  _emitter2.default.on("onPreLoadPageResources", function (e) {
	    prefetcher.onPreLoadPageResources(e);
	  });
	  _emitter2.default.on("onPostLoadPageResources", function (e) {
	    prefetcher.onPostLoadPageResources(e);
	  });
	}
	
	var sortResourcesByCount = function sortResourcesByCount(a, b) {
	  if (resourcesCount[a] > resourcesCount[b]) {
	    return 1;
	  } else if (resourcesCount[a] < resourcesCount[b]) {
	    return -1;
	  } else {
	    return 0;
	  }
	};
	
	var sortPagesByCount = function sortPagesByCount(a, b) {
	  if (pathCount[a] > pathCount[b]) {
	    return 1;
	  } else if (pathCount[a] < pathCount[b]) {
	    return -1;
	  } else {
	    return 0;
	  }
	};
	
	var fetchResource = function fetchResource(resourceName) {
	  var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
	
	  if (resourceStrCache[resourceName]) {
	    process.nextTick(function () {
	      cb(null, resourceStrCache[resourceName]);
	    });
	  } else {
	    // Find resource
	    var resourceFunction = resourceName.slice(0, 12) === "component---" ? asyncRequires.components[resourceName] || asyncRequires.layouts[resourceName] : asyncRequires.json[resourceName];
	
	    // Download the resource
	    resourceFunction(function (err, executeChunk) {
	      resourceStrCache[resourceName] = executeChunk;
	      cb(err, executeChunk);
	    });
	  }
	};
	
	var getResourceModule = function getResourceModule(resourceName, cb) {
	  if (resourceCache[resourceName]) {
	    process.nextTick(function () {
	      cb(null, resourceCache[resourceName]);
	    });
	  } else {
	    fetchResource(resourceName, function (err, executeChunk) {
	      if (err) {
	        cb(err);
	      } else {
	        var _module = preferDefault(executeChunk());
	        resourceCache[resourceName] = _module;
	        cb(err, _module);
	      }
	    });
	  }
	};
	
	var mountOrder = 1;
	var queue = {
	  empty: function empty() {
	    pathArray = [];
	    pathCount = {};
	    resourcesCount = {};
	    resourcesArray = [];
	    pages = [];
	  },
	  addPagesArray: function addPagesArray(newPages) {
	    pages = newPages;
	    var pathPrefix = "";
	    if (true) {
	      pathPrefix = ("");
	    }
	    findPage = (0, _findPage2.default)(newPages, pathPrefix);
	  },
	  addDevRequires: function addDevRequires(devRequires) {
	    syncRequires = devRequires;
	  },
	  addProdRequires: function addProdRequires(prodRequires) {
	    asyncRequires = prodRequires;
	  },
	  dequeue: function dequeue(path) {
	    return pathArray.pop();
	  },
	  enqueue: function enqueue(path) {
	    // Check page exists.
	    if (!pages.some(function (p) {
	      return p.path === path;
	    })) {
	      return false;
	    }
	
	    var mountOrderBoost = 1 / mountOrder;
	    mountOrder += 1;
	    // console.log(
	    // `enqueue "${path}", mountOrder: "${mountOrder}, mountOrderBoost: ${mountOrderBoost}`
	    // )
	
	    // Add to path counts.
	    if (!pathCount[path]) {
	      pathCount[path] = 1;
	    } else {
	      pathCount[path] += 1;
	    }
	
	    // Add path to queue.
	    if (!queue.has(path)) {
	      pathArray.unshift(path);
	    }
	
	    // Sort pages by pathCount
	    pathArray.sort(sortPagesByCount);
	
	    // Add resources to queue.
	    var page = findPage(path);
	    if (page.jsonName) {
	      if (!resourcesCount[page.jsonName]) {
	        resourcesCount[page.jsonName] = 1 + mountOrderBoost;
	      } else {
	        resourcesCount[page.jsonName] += 1 + mountOrderBoost;
	      }
	
	      // Before adding, checking that the JSON resource isn't either
	      // already queued or been downloading.
	      if (resourcesArray.indexOf(page.jsonName) === -1 && !resourceStrCache[page.jsonName]) {
	        resourcesArray.unshift(page.jsonName);
	      }
	    }
	    if (page.componentChunkName) {
	      if (!resourcesCount[page.componentChunkName]) {
	        resourcesCount[page.componentChunkName] = 1 + mountOrderBoost;
	      } else {
	        resourcesCount[page.componentChunkName] += 1 + mountOrderBoost;
	      }
	
	      // Before adding, checking that the component resource isn't either
	      // already queued or been downloading.
	      if (resourcesArray.indexOf(page.componentChunkName) === -1 && !resourceStrCache[page.jsonName]) {
	        resourcesArray.unshift(page.componentChunkName);
	      }
	    }
	
	    // Sort resources by resourcesCount.
	    resourcesArray.sort(sortResourcesByCount);
	    if (true) {
	      prefetcher.onNewResourcesAdded();
	    }
	
	    return true;
	  },
	  getResources: function getResources() {
	    return {
	      resourcesArray: resourcesArray,
	      resourcesCount: resourcesCount
	    };
	  },
	  getPages: function getPages() {
	    return {
	      pathArray: pathArray,
	      pathCount: pathCount
	    };
	  },
	  getPage: function getPage(pathname) {
	    return findPage(pathname);
	  },
	  has: function has(path) {
	    return pathArray.some(function (p) {
	      return p === path;
	    });
	  },
	  getResourcesForPathname: function getResourcesForPathname(path) {
	    var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
	
	    if (inInitialRender && navigator && navigator.serviceWorker && navigator.serviceWorker.controller && navigator.serviceWorker.controller.state === "activated") {
	      // If we're loading from a service worker (it's already activated on
	      // this initial render) and we can't find a page, there's a good chance
	      // we're on a new page that this (now old) service worker doesn't know
	      // about so we'll unregister it and reload.
	      if (!findPage(path)) {
	        navigator.serviceWorker.getRegistrations().then(function (registrations) {
	          for (var _iterator = registrations, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	            var _ref;
	
	            if (_isArray) {
	              if (_i >= _iterator.length) break;
	              _ref = _iterator[_i++];
	            } else {
	              _i = _iterator.next();
	              if (_i.done) break;
	              _ref = _i.value;
	            }
	
	            var registration = _ref;
	
	            registration.unregister();
	          }
	          window.location.reload();
	        });
	      }
	    }
	    inInitialRender = false;
	    // In development we know the code is loaded already
	    // so we just return with it immediately.
	    if (false) {
	      var page = findPage(path);
	      if (!page) return cb();
	      var pageResources = {
	        component: syncRequires.components[page.componentChunkName],
	        json: syncRequires.json[page.jsonName],
	        layout: syncRequires.layouts[page.layoutComponentChunkName],
	        page: page
	      };
	      cb(pageResources);
	      return pageResources;
	      // Production code path
	    } else {
	      var _page = findPage(path);
	
	      if (!_page) {
	        console.log("A page wasn't found for \"" + path + "\"");
	        return;
	      }
	
	      // Use the path from the page so the pathScriptsCache uses
	      // the normalized path.
	      path = _page.path;
	
	      // Check if it's in the cache already.
	      if (pathScriptsCache[path]) {
	        process.nextTick(function () {
	          cb(pathScriptsCache[path]);
	          _emitter2.default.emit("onPostLoadPageResources", {
	            page: _page,
	            pageResources: pathScriptsCache[path]
	          });
	        });
	        return pathScriptsCache[path];
	      }
	
	      _emitter2.default.emit("onPreLoadPageResources", { path: path });
	      // Nope, we need to load resource(s)
	      var component = void 0;
	      var json = void 0;
	      var layout = void 0;
	      // Load the component/json/layout and parallel and call this
	      // function when they're done loading. When both are loaded,
	      // we move on.
	      var done = function done() {
	        if (component && json && (!_page.layoutComponentChunkName || layout)) {
	          pathScriptsCache[path] = { component: component, json: json, layout: layout };
	          var _pageResources = { component: component, json: json, layout: layout };
	          cb(_pageResources);
	          _emitter2.default.emit("onPostLoadPageResources", {
	            page: _page,
	            pageResources: _pageResources
	          });
	        }
	      };
	      getResourceModule(_page.componentChunkName, function (err, c) {
	        if (err) {
	          console.log("Loading the component for " + _page.path + " failed");
	        }
	        component = c;
	        done();
	      });
	      getResourceModule(_page.jsonName, function (err, j) {
	        if (err) {
	          console.log("Loading the JSON for " + _page.path + " failed");
	        }
	        json = j;
	        done();
	      });
	
	      _page.layoutComponentChunkName && getResourceModule(_page.layoutComponentChunkName, function (err, l) {
	        if (err) {
	          console.log("Loading the Layout for " + _page.path + " failed");
	        }
	        layout = l;
	        done();
	      });
	
	      return undefined;
	    }
	  },
	  peek: function peek(path) {
	    return pathArray.slice(-1)[0];
	  },
	  length: function length() {
	    return pathArray.length;
	  },
	  indexOf: function indexOf(path) {
	    return pathArray.length - pathArray.indexOf(path) - 1;
	  }
	};
	
	module.exports = queue;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(117)))

/***/ }),

/***/ 465:
/***/ (function(module, exports) {

	module.exports = [{"componentChunkName":"component---src-templates-article-listing-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"articles-1.json","path":"/articles/1"},{"componentChunkName":"component---src-templates-article-listing-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"articles-2.json","path":"/articles/2"},{"componentChunkName":"component---src-templates-article-listing-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"articles-3.json","path":"/articles/3"},{"componentChunkName":"component---src-templates-article-listing-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"articles-4.json","path":"/articles/4"},{"componentChunkName":"component---src-templates-article-listing-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"articles-5.json","path":"/articles/5"},{"componentChunkName":"component---src-templates-article-listing-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"articles-6.json","path":"/articles/6"},{"componentChunkName":"component---src-templates-article-listing-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"articles-7.json","path":"/articles/7"},{"componentChunkName":"component---src-templates-article-listing-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"articles-8.json","path":"/articles/8"},{"componentChunkName":"component---src-templates-article-listing-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"articles-9.json","path":"/articles/9"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2018-02-a-little-information.json","path":"/articles/2018/02/a-little-information/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2017-11-loop-city.json","path":"/articles/2017/11/loop-city/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2017-10-memory-lane.json","path":"/articles/2017/10/memory-lane/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2016-07-dont-use-enum-umkay.json","path":"/articles/2016/07/dont-use-enum-umkay/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2014-10-a-new-site.json","path":"/articles/2014/10/a-new-site/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"photos-my-photos.json","path":"/photos/my-photos/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2008-12-all-i-need-is-a-guitar-solo.json","path":"/articles/2008/12/all-i-need-is-a-guitar-solo/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2008-07-treasures-of-the-past-promises-of-the-future.json","path":"/articles/2008/07/treasures-of-the-past-promises-of-the-future/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2008-04-i-think-im-turning-open-source.json","path":"/articles/2008/04/i-think-im-turning-open-source/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2008-04-bye-bye-u-3.json","path":"/articles/2008/04/bye-bye-u3/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2007-07-happy-4th.json","path":"/articles/2007/07/happy-4th/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2006-12-he-must-be-crazy.json","path":"/articles/2006/12/he-must-be-crazy/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2006-12-carbon-monoxide-and-you.json","path":"/articles/2006/12/carbon-monoxide-and-you/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2006-10-finally-all-back-in-business.json","path":"/articles/2006/10/finally-all-back-in-business/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2007-07-finally-all-back-in-business.json","path":"/articles/2007/07/finally-all-back-in-business/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2006-09-more-news-from-the-homestead.json","path":"/articles/2006/09/more-news-from-the-homestead/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2006-for-those-with-wimpy-stomaches.json","path":"/articles/2006/for-those-with-wimpy-stomaches/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2006-05-ouch-my-ground.json","path":"/articles/2006/05/ouch-my-ground/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2006-05-when-you-just-cant-wait.json","path":"/articles/2006/05/when-you-just-can't-wait/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2006-04-got-my-extra.json","path":"/articles/2006/04/got-my-extra/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2006-04-its-full-of-code.json","path":"/articles/2006/04/its-full-of-code/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2006-04-looking-at-radios.json","path":"/articles/2006/04/looking-at-radios/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2006-03-got-my-callsign.json","path":"/articles/2006/03/got-my-callsign/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2006-03-wires-up-passed-the-test.json","path":"/articles/2006/03/wires-up-passed-the-test/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2006-03-new-tune.json","path":"/articles/2006/03/new-tune/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2006-03-shiny-new-domain.json","path":"/articles/2006/03/shiny-new-domain/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2006-03-lessons-in-morse-code.json","path":"/articles/2006/03/lessons-in-morse-code/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2006-03-my-first-homebrew-radio.json","path":"/articles/2006/03/my-first-homebrew-radio/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2005-09-what-are-the-odds.json","path":"/articles/2005/09/what-are-the-odds/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2005-09-i-actually-lost-simcity.json","path":"/articles/2005/09/i-actually-lost-simcity/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2005-09-the-40-dollar-usb-cable.json","path":"/articles/2005/09/the-40-dollar-usb-cable/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2005-09-new-dinning-room-floors.json","path":"/articles/2005/09/new-dinning-room-floors/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2005-08-welcome-back-students-bye-bye-internet.json","path":"/articles/2005/08/welcome-back-students-bye-bye-internet/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2005-08-why-i-hate-css.json","path":"/articles/2005/08/why-i-hate-css/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2005-08-ironevents-finally-under-construction.json","path":"/articles/2005/08/ironevents-finally-under-construction/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2004-10-how-marvelous.json","path":"/articles/2004/10/how-marvelous/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2004-07-collapsable-folder-list.json","path":"/articles/2004/07/collapsable-folder-list/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2004-07-somewhere-up-in-the-sky.json","path":"/articles/2004/07/somewhere-up-in-the-sky/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2004-07-the-miracle-of-life.json","path":"/articles/2004/07/the-miracle-of-life/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2004-07-this-city-shall-surley-live.json","path":"/articles/2004/07/this-city-shall-surley-live/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2004-07-score-another-for-good-tunage.json","path":"/articles/2004/07/score-another-for-good-tunage/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2004-07-fun-with-networking.json","path":"/articles/2004/07/fun-with-networking/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2004-07-life-before-laptops.json","path":"/articles/2004/07/life-before-laptops/"},{"componentChunkName":"component---src-templates-article-js","layout":"article","layoutComponentChunkName":"component---src-layouts-article-js","jsonName":"articles-2004-07-holy-bloggers-batman.json","path":"/articles/2004/07/holy-bloggers-batman/"},{"componentChunkName":"component---src-pages-404-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"404.json","path":"/404/"},{"componentChunkName":"component---src-pages-index-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"index.json","path":"/"},{"componentChunkName":"component---src-pages-404-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"404-html.json","path":"/404.html"},{"componentChunkName":"component---src-pages-photos-index-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"photos.json","path":"/photos/"},{"componentChunkName":"component---src-pages-music-index-js","layout":"index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"music.json","path":"/music/"}]

/***/ }),

/***/ 233:
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (_ref) {
	  var getNextQueuedResources = _ref.getNextQueuedResources,
	      createResourceDownload = _ref.createResourceDownload;
	
	  var pagesLoading = [];
	  var resourcesDownloading = [];
	
	  // Do things
	  var startResourceDownloading = function startResourceDownloading() {
	    var nextResource = getNextQueuedResources();
	    if (nextResource) {
	      resourcesDownloading.push(nextResource);
	      createResourceDownload(nextResource);
	    }
	  };
	
	  var reducer = function reducer(action) {
	    switch (action.type) {
	      case "RESOURCE_FINISHED":
	        resourcesDownloading = resourcesDownloading.filter(function (r) {
	          return r !== action.payload;
	        });
	        break;
	      case "ON_PRE_LOAD_PAGE_RESOURCES":
	        pagesLoading.push(action.payload.path);
	        break;
	      case "ON_POST_LOAD_PAGE_RESOURCES":
	        pagesLoading = pagesLoading.filter(function (p) {
	          return p !== action.payload.page.path;
	        });
	        break;
	      case "ON_NEW_RESOURCES_ADDED":
	        break;
	    }
	
	    // Take actions.
	    // Wait for event loop queue to finish.
	    setTimeout(function () {
	      if (resourcesDownloading.length === 0 && pagesLoading.length === 0) {
	        // Start another resource downloading.
	        startResourceDownloading();
	      }
	    }, 0);
	  };
	
	  return {
	    onResourcedFinished: function onResourcedFinished(event) {
	      // Tell prefetcher that the resource finished downloading
	      // so it can grab the next one.
	      reducer({ type: "RESOURCE_FINISHED", payload: event });
	    },
	    onPreLoadPageResources: function onPreLoadPageResources(event) {
	      // Tell prefetcher a page load has started so it should stop
	      // loading anything new
	      reducer({ type: "ON_PRE_LOAD_PAGE_RESOURCES", payload: event });
	    },
	    onPostLoadPageResources: function onPostLoadPageResources(event) {
	      // Tell prefetcher a page load has finished so it should start
	      // loading resources again.
	      reducer({ type: "ON_POST_LOAD_PAGE_RESOURCES", payload: event });
	    },
	    onNewResourcesAdded: function onNewResourcesAdded() {
	      // Tell prefetcher that more resources to be downloaded have
	      // been added.
	      reducer({ type: "ON_NEW_RESOURCES_ADDED" });
	    },
	    getState: function getState() {
	      return { pagesLoading: pagesLoading, resourcesDownloading: resourcesDownloading };
	    },
	    empty: function empty() {
	      pagesLoading = [];
	      resourcesDownloading = [];
	    }
	  };
	};

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _apiRunnerBrowser = __webpack_require__(227);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(195);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouterDom = __webpack_require__(82);
	
	var _gatsbyReactRouterScroll = __webpack_require__(403);
	
	var _createBrowserHistory = __webpack_require__(106);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _domready = __webpack_require__(321);
	
	var _domready2 = _interopRequireDefault(_domready);
	
	var _emitter = __webpack_require__(57);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _pages = __webpack_require__(465);
	
	var _pages2 = _interopRequireDefault(_pages);
	
	var _redirects = __webpack_require__(466);
	
	var _redirects2 = _interopRequireDefault(_redirects);
	
	var _componentRenderer = __webpack_require__(229);
	
	var _componentRenderer2 = _interopRequireDefault(_componentRenderer);
	
	var _asyncRequires = __webpack_require__(228);
	
	var _asyncRequires2 = _interopRequireDefault(_asyncRequires);
	
	var _loader = __webpack_require__(138);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (true) {
	  __webpack_require__(311);
	}
	
	window.___emitter = _emitter2.default;
	
	_loader2.default.addPagesArray(_pages2.default);
	_loader2.default.addProdRequires(_asyncRequires2.default);
	window.asyncRequires = _asyncRequires2.default;
	window.___loader = _loader2.default;
	window.matchPath = _reactRouterDom.matchPath;
	
	var history = (0, _createBrowserHistory2.default)();
	
	// Convert to a map for faster lookup in maybeRedirect()
	var redirectMap = _redirects2.default.reduce(function (map, redirect) {
	  map[redirect.fromPath] = redirect;
	  return map;
	}, {});
	
	var maybeRedirect = function maybeRedirect(pathname) {
	  var redirect = redirectMap[pathname];
	
	  if (redirect != null) {
	    history.replace(redirect.toPath);
	    return true;
	  } else {
	    return false;
	  }
	};
	
	// Check for initial page-load redirect
	maybeRedirect(window.location.pathname);
	
	// Let the site/plugins run code very early.
	(0, _apiRunnerBrowser.apiRunnerAsync)("onClientEntry").then(function () {
	  // Let plugins register a service worker. The plugin just needs
	  // to return true.
	  if ((0, _apiRunnerBrowser.apiRunner)("registerServiceWorker").length > 0) {
	    __webpack_require__(234);
	  }
	
	  var navigateTo = function navigateTo(pathname) {
	    var redirect = redirectMap[pathname];
	
	    // If we're redirecting, just replace the passed in pathname
	    // to the one we want to redirect to.
	    if (redirect) {
	      pathname = redirect.toPath;
	    }
	
	    // If we're already at this path, do nothing.
	    if (window.location.pathname === pathname) {
	      return;
	    }
	
	    // Listen to loading events. If page resources load before
	    // a second, navigate immediately.
	    function eventHandler(e) {
	      if (e.page.path === _loader2.default.getPage(pathname).path) {
	        _emitter2.default.off("onPostLoadPageResources", eventHandler);
	        clearTimeout(timeoutId);
	        window.___history.push(pathname);
	      }
	    }
	
	    // Start a timer to wait for a second before transitioning and showing a
	    // loader in case resources aren't around yet.
	    var timeoutId = setTimeout(function () {
	      _emitter2.default.off("onPostLoadPageResources", eventHandler);
	      _emitter2.default.emit("onDelayedLoadPageResources", { pathname: pathname });
	      window.___history.push(pathname);
	    }, 1000);
	
	    if (_loader2.default.getResourcesForPathname(pathname)) {
	      // The resources are already loaded so off we go.
	      clearTimeout(timeoutId);
	      window.___history.push(pathname);
	    } else {
	      // They're not loaded yet so let's add a listener for when
	      // they finish loading.
	      _emitter2.default.on("onPostLoadPageResources", eventHandler);
	    }
	  };
	
	  // window.___loadScriptsForPath = loadScriptsForPath
	  window.___navigateTo = navigateTo;
	
	  // Call onRouteUpdate on the initial page load.
	  (0, _apiRunnerBrowser.apiRunner)("onRouteUpdate", {
	    location: history.location,
	    action: history.action
	  });
	
	  function attachToHistory(history) {
	    if (!window.___history) {
	      window.___history = history;
	
	      history.listen(function (location, action) {
	        if (!maybeRedirect(location.pathname)) {
	          (0, _apiRunnerBrowser.apiRunner)("onRouteUpdate", { location: location, action: action });
	        }
	      });
	    }
	  }
	
	  function shouldUpdateScroll(prevRouterProps, _ref) {
	    var pathname = _ref.location.pathname;
	
	    var results = (0, _apiRunnerBrowser.apiRunner)("shouldUpdateScroll", {
	      prevRouterProps: prevRouterProps,
	      pathname: pathname
	    });
	    if (results.length > 0) {
	      return results[0];
	    }
	
	    if (prevRouterProps) {
	      var oldPathname = prevRouterProps.location.pathname;
	
	      if (oldPathname === pathname) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  var AltRouter = (0, _apiRunnerBrowser.apiRunner)("replaceRouterComponent", { history: history })[0];
	  var DefaultRouter = function DefaultRouter(_ref2) {
	    var children = _ref2.children;
	    return _react2.default.createElement(
	      _reactRouterDom.Router,
	      { history: history },
	      children
	    );
	  };
	
	  _loader2.default.getResourcesForPathname(window.location.pathname, function () {
	    var Root = function Root() {
	      return (0, _react.createElement)(AltRouter ? AltRouter : DefaultRouter, null, (0, _react.createElement)(_gatsbyReactRouterScroll.ScrollContext, { shouldUpdateScroll: shouldUpdateScroll }, (0, _react.createElement)((0, _reactRouterDom.withRouter)(_componentRenderer2.default), {
	        layout: true,
	        children: function children(layoutProps) {
	          return (0, _react.createElement)(_reactRouterDom.Route, {
	            render: function render(routeProps) {
	              attachToHistory(routeProps.history);
	              var props = layoutProps ? layoutProps : routeProps;
	
	              if (_loader2.default.getPage(props.location.pathname)) {
	                return (0, _react.createElement)(_componentRenderer2.default, _extends({
	                  page: true
	                }, props));
	              } else {
	                return (0, _react.createElement)(_componentRenderer2.default, {
	                  location: { page: true, pathname: "/404.html" }
	                });
	              }
	            }
	          });
	        }
	      })));
	    };
	
	    var NewRoot = (0, _apiRunnerBrowser.apiRunner)("wrapRootComponent", { Root: Root }, Root)[0];
	    (0, _domready2.default)(function () {
	      return _reactDom2.default.render(_react2.default.createElement(NewRoot, null), typeof window !== "undefined" ? document.getElementById("___gatsby") : void 0, function () {
	        (0, _apiRunnerBrowser.apiRunner)("onInitialClientRender");
	      });
	    });
	  });
	});

/***/ }),

/***/ 466:
/***/ (function(module, exports) {

	module.exports = []

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _emitter = __webpack_require__(57);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pathPrefix = "/";
	if (false) {
	  pathPrefix = __PATH_PREFIX__ + "/";
	}
	
	if ("serviceWorker" in navigator) {
	  navigator.serviceWorker.register(pathPrefix + "sw.js").then(function (reg) {
	    reg.addEventListener("updatefound", function () {
	      // The updatefound event implies that reg.installing is set; see
	      // https://w3c.github.io/ServiceWorker/#service-worker-registration-updatefound-event
	      var installingWorker = reg.installing;
	      console.log("installingWorker", installingWorker);
	      installingWorker.addEventListener("statechange", function () {
	        switch (installingWorker.state) {
	          case "installed":
	            if (navigator.serviceWorker.controller) {
	              // At this point, the old content will have been purged and the fresh content will
	              // have been added to the cache.
	              // We reload immediately so the user sees the new content.
	              // This could/should be made configurable in the future.
	              window.location.reload();
	            } else {
	              // At this point, everything has been precached.
	              // It's the perfect time to display a "Content is cached for offline use." message.
	              console.log("Content is now available offline!");
	              _emitter2.default.emit("sw:installed");
	            }
	            break;
	
	          case "redundant":
	            console.error("The installing service worker became redundant.");
	            break;
	        }
	      });
	    });
	  }).catch(function (e) {
	    console.error("Error during service worker registration:", e);
	  });
	}

/***/ }),

/***/ 321:
/***/ (function(module, exports, __webpack_require__) {

	/*!
	  * domready (c) Dustin Diaz 2014 - License MIT
	  */
	!function (name, definition) {
	
	  if (true) module.exports = definition()
	  else if (typeof define == 'function' && typeof define.amd == 'object') define(definition)
	  else this[name] = definition()
	
	}('domready', function () {
	
	  var fns = [], listener
	    , doc = document
	    , hack = doc.documentElement.doScroll
	    , domContentLoaded = 'DOMContentLoaded'
	    , loaded = (hack ? /^loaded|^c/ : /^loaded|^i|^c/).test(doc.readyState)
	
	
	  if (!loaded)
	  doc.addEventListener(domContentLoaded, listener = function () {
	    doc.removeEventListener(domContentLoaded, listener)
	    loaded = 1
	    while (listener = fns.shift()) listener()
	  })
	
	  return function (fn) {
	    loaded ? setTimeout(fn, 0) : fns.push(fn)
	  }
	
	});


/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/* global document: false, __webpack_require__: false */
	patch();
	
	function patch() {
	  var head = document.querySelector("head");
	  var ensure = __webpack_require__.e;
	  var chunks = __webpack_require__.s;
	  var failures;
	
	  __webpack_require__.e = function (chunkId, callback) {
	    var loaded = false;
	    var immediate = true;
	
	    var handler = function handler(error) {
	      if (!callback) return;
	
	      callback(__webpack_require__, error);
	      callback = null;
	    };
	
	    if (!chunks && failures && failures[chunkId]) {
	      handler(true);
	      return;
	    }
	
	    ensure(chunkId, function () {
	      if (loaded) return;
	      loaded = true;
	
	      if (immediate) {
	        // webpack fires callback immediately if chunk was already loaded
	        // IE also fires callback immediately if script was already
	        // in a cache (AppCache counts too)
	        setTimeout(function () {
	          handler();
	        });
	      } else {
	        handler();
	      }
	    });
	
	    // This is |true| if chunk is already loaded and does not need onError call.
	    // This happens because in such case ensure() is performed in sync way
	    if (loaded) {
	      return;
	    }
	
	    immediate = false;
	
	    onError(function () {
	      if (loaded) return;
	      loaded = true;
	
	      if (chunks) {
	        chunks[chunkId] = void 0;
	      } else {
	        failures || (failures = {});
	        failures[chunkId] = true;
	      }
	
	      handler(true);
	    });
	  };
	
	  function onError(callback) {
	    var script = head.lastChild;
	
	    if (script.tagName !== "SCRIPT") {
	      if (typeof console !== "undefined" && console.warn) {
	        console.warn("Script is not a script", script);
	      }
	
	      return;
	    }
	
	    script.onload = script.onerror = function () {
	      script.onload = script.onerror = null;
	      setTimeout(callback, 0);
	    };
	  }
	}

/***/ }),

/***/ 543:
/***/ (function(module, exports) {

	function n(n){return n=n||Object.create(null),{on:function(t,o){(n[t]||(n[t]=[])).push(o)},off:function(t,o){n[t]&&n[t].splice(n[t].indexOf(o)>>>0,1)},emit:function(t,o){(n[t]||[]).map(function(n){n(o)}),(n["*"]||[]).map(function(n){n(t,o)})}}}module.exports=n;
	//# sourceMappingURL=mitt.js.map

/***/ }),

/***/ 117:
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),

/***/ 336:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(162898551421021, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(237) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 337:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(35783957827783, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(238) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 338:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(188813165217535, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(239) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(61671625695467, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(240) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(273643807223514, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(241) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(131683993344931, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(242) })
	        }
	      });
	     }
	    

/***/ })

});


// WEBPACK FOOTER //
// app-89c39dc951bb3c6f1c87.js